'use strict';
import isFunction from 'lodash/isFunction';
import isUndefined from 'lodash/isUndefined';
import {createEventHandler} from 'recompose';
import 'rxjs/add/operator/debounceTime';
import {isIosBuild} from '../../config/constants';


const LONGPRESS_DURATION_THRESHOLD = 600;
const TAP_DISTANCE_THRESHOLD = 4;

export class ContextMenuPolyfillService {
  static $injext = [];

  static SERVICE_NAME = 'contextMenuPolyfillService';

  constructor() {
    if (this.usePolyfill()) {
      const {
        handler: contextMenuHandler,
        stream: contextMenu$,
      } = createEventHandler();
      this.contextMenuHandler = contextMenuHandler;
      const {
        handler: touchStartHandler,
        stream: touchStart$,
      } = createEventHandler();
      const {
        handler: touchMoveHandler,
        stream: touchMove$,
      } = createEventHandler();
      const {
        handler: touchEndHandler,
        stream: touchEnd$,
      } = createEventHandler();
      this.handlers = {
        touchStartHandler,
        touchMoveHandler,
        touchEndHandler,
      };

      this.touchStartSubscription = touchStart$.subscribe(this.onTouchStart.bind(this));
      this.touchMoveSubscription = touchMove$.subscribe(this.onTouchMove.bind(this));
      this.touchEndSubscription = touchEnd$.subscribe(this.onTouchEnd.bind(this));

      this.contextMenuSubscription = contextMenu$
        .debounceTime(300)
        .subscribe(payload => {
          if (isFunction(payload.onContextMenu)) {
            if (!isUndefined(payload.bindParam)) {
              payload.onContextMenu(payload.event, payload.bindParam);
            } else {
              payload.onContextMenu(payload.event);
            }
          }
        });
    }
  }

  getHandlers() {
    return this.handlers;
  }

  usePolyfill() {
    return isIosBuild();
  }

  onTouchStart(payload) {
    this.startT = new Date().getTime();
    this.startX = payload.event.targetTouches[0].pageX;
    this.startY = payload.event.targetTouches[0].pageY;
    this.distanceTravelledX = 0;
    this.distanceTravelledY = 0;
    this.targetTouches = payload.event.targetTouches.length;

    this.pressed = true;

    if (this.contextTimeout)
      clearTimeout(this.contextTimeout);

    this.contextTimeout = setTimeout(() => {
      this.contextTimeout = null;
      if (this.pressed
        && this.distanceTravelledX < TAP_DISTANCE_THRESHOLD
        && this.distanceTravelledY < TAP_DISTANCE_THRESHOLD
        && this.targetTouches === 1
        && this.contextMenuHandler) {
        this.contextMenuHandler(payload);
      }
    }, LONGPRESS_DURATION_THRESHOLD);
  }

  onTouchMove(payload) {
    if (payload.event.targetTouches.length === 1) {
      const relativeX = payload.event.targetTouches[0].pageX;
      const relativeY = payload.event.targetTouches[0].pageY;

      this.distanceTravelledX += Math.abs(relativeX);
      this.distanceTravelledY += Math.abs(relativeY);
    } else {
      this.targetTouches = payload.event.targetTouches.length;
    }
  }

  onTouchEnd() {
    this.pressed = false;
  }
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/react-utils/ContextMenuPolyfill.js